import {IconButton, Menu, styled, Typography} from "@mui/material";
import {MouseEvent, useState} from "react";
import {Calendar} from "react-datepicker2";
import CalendarIcon from "assets/icons/CalendarIcon";
import {formatDate} from "helpers";

const InputWrapper = styled("div")(({theme}) => ({
    padding: "2px 4px",
    border: `solid 2px #e6e6e6`,
    display: "flex",
    borderRadius: 4,
    alignItems: "center",
    justifyContent: "space-between",
    height: "40px",
    width: "100%",
}));
const DisableInputWrapper = styled("div")(({theme}) => ({
    padding: "2px 4px",
    border: `solid 2px #e6e6e6`,
    display: "flex",
    borderRadius: 4,
    alignItems: "center",
    justifyContent: "space-between",
    height: "40px",
    width: "100%",
    backgroundColor: "#EDEEF0",
}));

const InputContainer = styled("div")(({theme}) => ({
    width: "100%",
    display: "flex",
    flexDirection: "column",
}));

const CustomCalendarInput = ({
                                 name,
                                 label,
                                 isGregorian,
                                 required,
                                 stateLess = false,
                                 onChange,
                                 disabled = false,
                                 value,
                             }: {
    name: string;
    label: string;
    required?: boolean;
    isGregorian?: boolean;
    stateLess?: boolean;
    onChange?: (value: any) => void;
    disabled?: boolean;
    value?: any;
}) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);

    const handleClick = (event: MouseEvent<HTMLElement>) => {
        !disabled && setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleChange = (date: any) => {
        //@ts-ignore
        onChange(formatDate(date, isGregorian));
    };

    return (
        <InputContainer>
            <Typography fontWeight="bold" variant="body2" sx={{marginBottom: "5px"}}>
                {label}&nbsp;{required ? "*" : ""}
            </Typography>
            {disabled ? (
                <DisableInputWrapper>
                    <Typography variant="body2">{value}</Typography>
                    <IconButton onClick={handleClick}>
                        <CalendarIcon/>
                    </IconButton>
                </DisableInputWrapper>
            ) : (
                <InputWrapper>
                    <Typography variant="body2">{value}</Typography>
                    <IconButton onClick={handleClick}>
                        <CalendarIcon/>
                    </IconButton>
                </InputWrapper>
            )}
            <Menu
                id="demo-positioned-menu"
                aria-labelledby="demo-positioned-button"
                anchorEl={anchorEl}
                open={open}
                sx={{
                    "& div": {
                        "& ul": {
                            paddingTop: 0,
                            paddingBottom: 0,
                        },
                    },
                }}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
            >
                <Calendar
                    isGregorian={String(isGregorian) === "true"}
                    onChange={(date) => {
                        handleChange(date);
                        handleClose();
                    }}
                />
            </Menu>
        </InputContainer>
    );
};

export default CustomCalendarInput;
